import { createHash } from 'crypto-browserify';

// eslint-disable-next-line import/prefer-default-export
export function createSha256(str) {
  return str ? createHash('sha256').update(str).digest('hex') : str;
}
